var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          staticStyle: { width: "100px" },
          attrs: { size: "mini" },
          model: {
            value: _setup.currentLang,
            callback: function ($$v) {
              _setup.currentLang = $$v
            },
            expression: "currentLang",
          },
        },
        _vm._l(_setup.options, function (opt) {
          return _c("el-option", {
            key: opt.value,
            attrs: { label: opt.label, value: opt.value },
          })
        }),
        1
      ),
      _c("span", { staticStyle: { "margin-left": "10px" } }, [
        _vm._v(_vm._s(_setup.currentText)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }